module.exports = __webpack_public_path__ + "img/1557614070999359489.570f0668.png";